import styled from 'styled-components'
import FormBase from 'components/form/controller'

export const Form = styled(FormBase)`
    width: 100%;
    position: relative;
`